import { render, staticRenderFns } from "./statisticsBClassifyCustomer.pug?vue&type=template&id=4c44d976&lang=pug&"
import script from "./statisticsBClassifyCustomer.ts?vue&type=script&lang=ts&"
export * from "./statisticsBClassifyCustomer.ts?vue&type=script&lang=ts&"
import style0 from "./statisticsBClassifyCustomer.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports